import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerClinic from '../../assets/logo/ic_marker_clinic.png';
import markerE from '../../assets/logo/ic_marker_e.png';

const customIconClinic = L.icon({
  iconUrl: markerClinic,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const customIconE = L.icon({
  iconUrl: markerE,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const Map = ({ location }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    const map = L.map(mapRef.current, { zoomControl: false })
      .setView([location?.lat, location?.lng], 13);

    // agrega una capa de mapa
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(map);

    // agrega un marcador para la ubicación del consultorio
    const marker = L.marker([location.lat, location.lng], { icon: customIconClinic }).addTo(map);
    marker.bindPopup(`<strong>Centro de especialidades Oftalmológicas</strong><br>${location.direccion}`).openPopup();

    // agrega marcadores para los estacionamientos cercanos
    if (location?.playas_estacionamiento.length !== 0) {
      location.playas_estacionamiento.forEach((playa) => {
        const parkingMarker = L.marker([playa.lat, playa.lng], { icon: customIconE }).addTo(map);
        parkingMarker.bindPopup(`<strong>${playa.nombre}</strong><br>${playa.direccion}`);
      });
    }

    // Agrega el control de zoom a la esquina inferior derecha
    L.control.zoom({ position: 'bottomright' }).addTo(map);

    return () => {
      // Al desmontar el componente, destruir el mapa
      map.remove();
    };
  }, [location]);

  return <div ref={mapRef} style={{ height: '400px', width: '550px' }} />;
};

Map.propTypes = {
  location: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
    direccion: PropTypes.string,
    playas_estacionamiento: PropTypes.arrayOf(PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
      nombre: PropTypes.string,
      direccion: PropTypes.string
    }))
  }).isRequired,
};

export default Map;
